

<ng-template #template>
  <ng-container *ngIf="missedCallsByUser | async as _missedCallsByUser; else (loading$ | async)">
    <stacked-bar-chart *ngIf="_missedCallsByUser.length > 0 else (noResults$ | async)"
                       [results]="_missedCallsByUser"
                       [options]="missedCallsByUserOptions"
                       (select)="onSelect($event)">
    </stacked-bar-chart>
  </ng-container>
</ng-template>


